import React from "react";
import saveAs from "file-saver";
import JSZip from "jszip";

const DownloadMultipleFiles = ({ fileUrls, zipFileName, buttonText }) => {
  console.log({ fileUrls, zipFileName, buttonText });
  const handleDownload = () => {
    const zip = new JSZip();

    const promises = fileUrls?.map(async (url, index) => {
      console.log({ url });
      const urlParts = url.split("/");
      console.log({ urlParts });
      const fileName = urlParts[urlParts.length - 1];
      console.log({ fileName });
      const response = await fetch(url);
      console.log({ response });

      const blob = await response.blob();
      console.log({ blob });

      zip.file(fileName, blob);
    });

    Promise.all(promises).then(() => {
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, zipFileName);
      });
    });
  };

  return (
    <div>
      <button className=" btn bg-primary text-white" onClick={handleDownload}>
        {buttonText}
      </button>
    </div>
  );
};

export default DownloadMultipleFiles;
